import React, { MouseEventHandler } from 'react';
import classNames from 'classnames';
import styles from './button.module.scss';

interface IButton extends React.PropsWithChildren, React.ButtonHTMLAttributes<HTMLButtonElement> {
    onclick: MouseEventHandler<HTMLButtonElement> | undefined;
    className?: string;
    link?: boolean;
    small?: boolean;
    gray?: boolean;
    block?: boolean;
    hide?: boolean;
}

const Button: React.FC<IButton> = ({ onclick, className, link, small, gray, block, hide, children, ...props }) => {
    return (
        <button
            type="button"
            className={classNames(
                styles.button,
                link && styles.link,
                small && styles.small,
                gray && styles.gray,
                block && styles.block,
                hide && styles.hide,
                className
            )}
            onClick={onclick}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;
